// extracted by mini-css-extract-plugin
export default {"adListWrapper":"adList_adListWrapper__6q18+","listTitle":"adList_listTitle__KsGen"};